import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInitiatedStatusIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5V15.5Z",
			fill: "#0055D4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.99944,
			cy: 7.99993,
			r: 6.96429,
			stroke: "#0055D4",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "1 3"
		})
	]
});
const ForwardRef = forwardRef(SvgInitiatedStatusIcon);
export default ForwardRef;
